import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';
import GeoUtils from '../geoUtils.js';

const NUM_X_SUBDIVS = 3;
const NUM_Y_SUBDIVS = 3;
const NUM_Z_SUBDIVS = 3;

// x^2, 2*x*(1-x), (1-x)^2
const WEIGHT_FUNCTIONS = [
	(x) => { return x*x; },
	(x) => { return 2*x*(1-x); },
	(x) => { return (1-x)*(1-x); },
];

export default class NodeLatticeDeform extends Node
{

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.generateLatticeInputs(NUM_X_SUBDIVS, NUM_Y_SUBDIVS, NUM_Z_SUBDIVS);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'latticeDeform';
	}

	generateLatticeInputs(iXSubdivs, iYSubdivs, iZSubdivs)
	{
		for(let iX = 0; iX < iXSubdivs; iX++)
		{
			for(let iY = 0; iY < iYSubdivs; iY++)			
			{
				for(let iZ = 0; iZ < iZSubdivs; iZ++)
				{
					this.addInput(PARAM_TYPE.FLOAT, `point_${iX}${iY}${iZ}_x`, 0.0, { minValue: -10, maxValue: 10, units: PARAM_UNITS.METERS, isWholeInputHidden: true });
					this.addInput(PARAM_TYPE.FLOAT, `point_${iX}${iY}${iZ}_y`, 0.0, { minValue: -10, maxValue: 10, units: PARAM_UNITS.METERS, isWholeInputHidden: true });
					this.addInput(PARAM_TYPE.FLOAT, `point_${iX}${iY}${iZ}_z`, 0.0, { minValue: -10, maxValue: 10, units: PARAM_UNITS.METERS, isWholeInputHidden: true });
				}
			}
		}
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		let bbox = Utils3D.getObjectsBBoxWithChildren(pGeoList);

		let latticePoints = [];
		for(let iY = 0; iY < NUM_Y_SUBDIVS; iY++)
		{
			for(let iX = 0; iX < NUM_X_SUBDIVS; iX++)
			{
				for(let iZ = 0; iZ < NUM_Z_SUBDIVS; iZ++)
				{
					if(!latticePoints[iX])
						latticePoints[iX] = [];
					if(!latticePoints[iX][iY])
						latticePoints[iX][iY] = [];

					// TODO: These need to be scaled relative to the mesh, because the latticePoints param is actually a set of scales
					latticePoints[iX][iY][iZ] = new BABYLON.Vector3(inputValues[`point_${iX}${iY}${iZ}_x`], inputValues[`point_${iX}${iY}${iZ}_y`], inputValues[`point_${iX}${iY}${iZ}_z`]);
				}
			}
		}

		for(let pSrcMesh of pGeoList)
			GeoUtils.deformSingleMesh(pSrcMesh, latticePoints, WEIGHT_FUNCTIONS, bbox.minimumWorld, bbox.maximumWorld);

		return pGeoList;
	}
}